/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
// 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html?spm=a2d5h.23431112.0.0
function openOtherApp(params, context) {
    context === null || context === void 0 ? void 0 : context.WVCall('WVNavUrls.openOtherApp', params);
}

export { openOtherApp as default };
